/* React */
import { useState } from 'react'

/* Redux */
import Redux from './Redux'

/* Material */
import Typo from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import useStyles from './styles'

/* Components */
import Loading from 'src/components/Loading'
import GoogleRecaptchaInfos from 'src/components/GoogleRecaptchaInfos'
import { pageBuilderButtonSx } from 'src/theme/pageBuilderButtons'

/* Functions */
import loginRequest from './functions/loginRequest'
import getRecaptchaToken from 'src/functions/getRecaptchaToken'

const LoginForm = () => {
  const classes = useStyles()
  const { reduxLogin } = Redux()

  const [email, changeEmail] = useState<string>('')
  const [password, changePassword] = useState<string>('')

  const [loading, toggleLoading] = useState(false)
  const [tried, toggleTried] = useState(false)

  if (loading) return <Loading />

  return <div>

    <Typo component='p' variant='body1' color='inherit' gutterBottom>
      Loggen Sie sich mit Ihrer Email-Adresse und Ihrem Passwort ein
    </Typo>
    
    <form 
      id='form-login' 
      className={classes.loginForm}
      onSubmit={async e=>{
        toggleLoading(true)
        e.preventDefault()
        toggleTried(true)
        const recaptchaToken = await getRecaptchaToken('login')
        if (!recaptchaToken) { toggleLoading(false); return }
        const token = await loginRequest(email, password, false, recaptchaToken)
        if (token) reduxLogin({ token, email })
        toggleLoading(false)
      }}
    >

      <TextField 
        placeholder='Email'
        label="E-Mail-Adresse"
        name='email'
        className='email'
        autoComplete='email'
        type='email'
        value={email} required inputProps={{ maxLength: 100 }}
        onChange={({target:{value}})=>changeEmail(value)}

        helperText={tried && "Bitte geben Sie eine gültige Email-Adresse ein"}
      />
      
      <TextField 
        placeholder='Passwort'
        label="Passwort"
        name='password'
        className='password'
        autoComplete='password current-password'
        type='password'
        value={password} required inputProps={{ minLength: 8, maxLength: 100 }}
        onChange={({target:{value}})=>changePassword(value)}

        helperText={tried && "Ihr Passwort muss mindestens 8 Zeichen lang sein"}
      />

      <div className={classes.dsgvoRecaptcha}>
        <GoogleRecaptchaInfos />
      </div>

      <Button 
        variant='contained' color='primary' size='large'
        type='submit'
        className={classes.loginButton}
        sx={pageBuilderButtonSx}
      >
        Login
      </Button>

    </form>

  </div>
}

export default LoginForm
